import React, { FC } from 'react';
import { usePermitRequestContext } from '../../../../../contexts/PermitRequestContext';
import InputGroup from '../../../../../components/form/InputGroup';
import PermitType from '../../../../../types/permit.type';
import RadioOutlineBtn from '../../../../../components/form/radios/RadioOutlineBtn';
import RadioBtnsContainer from '../../../../../components/form/radios/RadioBtnsContainer';
import { useProjectConfigContext } from '../../../../../contexts/ProjectConfigContext';
import useTags from '../../../../../hooks/useTags';
import addRequestPageLang from '../../../../../data/lang/add-request-page.lang';

type Props = {
    handleClick: (e: React.MouseEvent<HTMLInputElement>) => void
}

const StudentPermitType: FC<Props> = ({ handleClick }) => {

    const { projectConfigState } = useProjectConfigContext();
    const { handleChangeFile, Formik } = usePermitRequestContext();
    const { values, errors, touched, handleBlur } = Formik;
    const permitType = values.permitType;

    
    const generateTag = useTags();
    
    const label = generateTag(addRequestPageLang, 'form.permit-types.student-parking-tag.title-tag');
    const yesLabel = generateTag(addRequestPageLang, 'form.permit-types.student-parking-tag.options.yesLabel');
    const noLabel = generateTag(addRequestPageLang, 'form.permit-types.student-parking-tag.options.noLabel');
    const inputLabel = generateTag(addRequestPageLang, 'form.permit-types.student-parking-tag.additional-file-label');

    const permitTypes = projectConfigState.addRequestPageConfig.permitTypes;
    const hasStudent = permitTypes.student;
    const showStudentPermitFile = permitType === PermitType.STUDENT;

    if (!hasStudent) {
        return null;
    }

    return (
        <>
            <div className="row">
                <div className='col-12'>
                    <RadioBtnsContainer label={label}>
                        <RadioOutlineBtn
                            isChecked={permitType !== PermitType.STUDENT}
                            label={noLabel}
                            value={PermitType.REGULAR}
                            onClick={handleClick}
                            id="studentPermitYes"
                            name='studentPermit'
                        />
                        <RadioOutlineBtn
                            isChecked={permitType === PermitType.STUDENT}
                            label={yesLabel}
                            value={PermitType.STUDENT}
                            onClick={handleClick}
                            id="studentPermitNo"
                            name='studentPermit'
                        />
                    </RadioBtnsContainer>
                </div>
            </div>

            {showStudentPermitFile ? (
                <div className="row">
                    <div className='col-12 col-sm-4'>
                        <InputGroup
                            name={'extraFile1'}
                            label={inputLabel}
                            type='file'
                            isRequired={true}
                            handleBlur={handleBlur}
                            handleChange={(event) => {
                                handleChangeFile('extraFiles.extraFile1', 'extraFile1', event.currentTarget.files[0]);
                            }}
                            //@ts-ignore
                            errorMsg={(errors.extraFile1 && touched.extraFile1) ? errors.extraFile1 : undefined}
                        />
                    </div>
                </div>
            ) : ''}
        </>
    );
}

export default StudentPermitType;